import BeanForm from '../components/BeanForms'

const RoasterHome = () => {
  return (
    <div className="profile">
      <BeanForm />
    </div>
  )
}
export default RoasterHome
